// libs
import React, { memo, useRef } from 'react';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// widgets
import Content from './widgets/Content';
import ActionButton from './widgets/ActionButton/ActionButton';
// components
import Menu from '@/components/Menu';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// styles
import styles from './DatePicker.module.scss';
function DatePickerBox({ value, defaultMonth, setValue, disabledDateMatcher, placeholder, label, errorMsg, disabled, className, }) {
    const menuApiRef = useRef(null);
    const closeMenu = () => {
        if (menuApiRef.current) {
            menuApiRef.current.isOpen && menuApiRef.current.close();
        }
    };
    const openMenu = () => {
        if (menuApiRef.current) {
            !menuApiRef.current.isOpen && menuApiRef.current.open();
        }
    };
    return (React.createElement("div", { className: styles.container },
        label && (React.createElement(Text, { variant: DlsFontVariants.header_H5_Bold, color: DlsColorTokens.text_Low_Emphasis, className: styles.containerTitle }, label)),
        React.createElement(Menu, { Content: Content, placement: "bottom-start", contentProps: {
                closeMenu,
                setValue,
                value,
                defaultMonth,
                disabledDateMatcher,
            }, autoUpdatePosition: true, ref: menuApiRef },
            React.createElement(ActionButton, { value: value, placeholder: placeholder, openMenu: openMenu, errorMsg: errorMsg, disabled: disabled, className: className }))));
}
export default memo(DatePickerBox);
